
import { Component, Mixins, Prop } from "vue-property-decorator";
import {
  Document,
  Section,
} from "../../../../domain/document";
import { EditingDocument } from "..";
import ExtraDocumentAccessibleMixin from "./ExtraDocumentAccessibleMixin.vue";

@Component
export default class ExtraDocumentEditableMixin extends Mixins(ExtraDocumentAccessibleMixin) {
  editingSource: EditingDocument;
  writePropertyWhenValid: (writer: (source: EditingDocument) => void) => void;

  @Prop()
  initializeNewExtraDocument: (extraDocument: Document, document: Document) => Promise<void>;

  @Prop()
  getExtraDocument: (patientId: string, formatId: number) => Promise<Document>;

  async mergeExtraDocument(extraDocument: Document, destinationSectionIndex: number): Promise<void> {
    await this.initializeNewExtraDocument(extraDocument, this.editingSource.source);
    const editingDocument = new EditingDocument(extraDocument);
    try {
      await editingDocument.initialize(); // 計算式の更新等初期化する.
    } catch (e) {
      this.$error("エラー", e.message, e);
    }
    this.writePropertyWhenValid(s => s.insertItemSet(
      extraDocument.itemSets[0],
      extraDocument.sections,
      destinationSectionIndex
    ));
  }

  public removeExtraSection(section: Section): void {
    this.writePropertyWhenValid(s => s.removeSection(section));
  }
}
